import { LOGIN, LOGOUT, MODIFY_NAME, SIGN_UP } from "../actions/actions.types"

const INITIAL_STATE = null;

const userReducer = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case LOGIN: 
        case SIGN_UP:
            return action.payload;
        
        case MODIFY_NAME:
            return {
                ...state,
                firstName: action.payload.firstName,
                middleName: action.payload.middleName,
                lastName: action.payload.lastName,
            }

        case LOGOUT:
            return INITIAL_STATE;

        default:
            return state;
    }
}

export default userReducer;